import { useAuthorization, useAuthState } from "_ReactContext/AuthContext";
import React from "react";

const useJobFieldsToHide = (languages: any) => {
    const { isFeatureAuthorized } = useAuthorization();
    const aiEnabled = isFeatureAuthorized("ManageAISettings");
    const { company } = useAuthState();
    const defaultValues: string[] = [];

    if (!aiEnabled) {
        defaultValues.push("enableMatchApplicants");
    }

    if (company?.enableResponsibilitiesField !== true) {
        defaultValues.push("responsibilities");
    }
    if (company?.enableRequirementsField !== true) {
        defaultValues.push("requirements");
    }

    if (languages && languages.length <= 1) {
        defaultValues.push("translatedData");
    }

    const [fieldsToHide, setFieldsToHide] = React.useState<string[]>(
        defaultValues
    );

    React.useEffect(() => {
        if (languages && languages.length <= 1) {
            const fName = "translatedData";
            if (!fieldsToHide.find((f) => f === fName)) {
                const newFieldsToHide = [...fieldsToHide].filter(
                    (f) => f !== "translatedData"
                );
                newFieldsToHide.push("translatedData");
                setFieldsToHide([...newFieldsToHide]);
            }
        }
    }, [languages]);

    return { fieldsToHide, setFieldsToHide };
};

export default useJobFieldsToHide;
